import NewFooter from '../../src/components/HomePage/NewFooter';
import { HomeWrapper } from '../../src/components/HomePage/HomeBanner/styled';
import GlobalStyle from '../../src/styles/globalStylesV2';
import NewHeader from '../../src/components/HomePage/NewHeader';
import { utilitesFetcher } from '../../src/datafetchers/HomePage';
import { Title } from '../../src/components/HomePage/Articles/styled';
import Tool from '../../src/components/ExploreTools/Tools';
import { ExploreTools } from '../../src/components/ExploreTools/Tools/styled';
import ToolBanner from '../../src/components/ExploreTools/Tools/ToolBanner';
import { revalidate_1_hour } from '../../src/Utils/SEO/constants';
import { storeDataFetcher } from '../../src/datafetchers/Store';
import { getFilteredCategoryContent } from '../../src/Utils/helper';
import { NextSeo } from 'next-seo';

export async function getStaticProps() {
  const ToolsData = await utilitesFetcher();
  let data = await storeDataFetcher({
    skip: 0,
    limit: 10,
    lang: 'en',
    inApp: false,
    desktopView: true,
    key: 'store',
  });
  return {
    props: {
      tools: ToolsData,
      categoryData: getFilteredCategoryContent(data?.data?.categories),
    },
    revalidate: revalidate_1_hour,
  };
}

export default function index(props) {
  const { tools, categoryData } = props;
  const item = [];
  tools?.data.map((element, index) => {
    item.push(
      <>
        <ExploreTools key={index}>
          <Title>{element.title}</Title>
          <Tool data={element?.tools}></Tool>
        </ExploreTools>
      </>,
    );
  });
  const metaTitle = 'Discover TTC, Pregnancy & Baby Tools | MyloFamily';
  const metaDescription =
    'Discover our range of useful tools to help you on your conception, pregnancy and parenting journey.';
  return (
    <>
      <NextSeo title={metaTitle} description={metaDescription} />
      <GlobalStyle />
      <NewHeader nostrip={true} categoryData={categoryData} />
      <HomeWrapper noPadding>
        <ToolBanner />
        {item}
      </HomeWrapper>
      <NewFooter></NewFooter>
    </>
  );
}
